module.exports = __webpack_public_path__ + "img/slavko-kazakov.4bc5502c.jpg";